import {UpdateProfileData} from 'attendee/Auth/Interfaces/update_profile'
import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {ErrorMsg} from 'attendee/Auth/Register'
import {useFormik} from 'formik'
import React, {useMemo, useState} from 'react'
import {toast} from 'react-toastify'
import {getProfileUpdateSchema} from 'utils/validation-schema'
import {useI18n} from 'i18n/I18nContext'

export default function ProfileUpdate() {
  const {user, updateProfile} = useAuth()
  const [isBtnDisable, setBtnDisable] = useState(false)
  const {t} = useI18n()
  const profileSchema = useMemo(() => getProfileUpdateSchema(t), [t])

  const {handleSubmit, handleBlur, handleChange, values, errors, touched} =
    useFormik({
      initialValues: {
        first_name: user?.first_name ?? '',
        last_name: user?.last_name ?? '',
        email: user?.email ?? '',
        delivery_names: user?.delivery_names ?? '',
        delivery_phone: user?.delivery_phone ?? '',
        delivery_address: user?.delivery_address ?? '',
      },
      validationSchema: profileSchema,
      onSubmit: async (values: UpdateProfileData) => {
        setBtnDisable(true)
        const result = await updateProfile(values)

        if (result === true) {
          toast.success(t('form.profile.toastSaved'))
        }

        setBtnDisable(false)
      },
    })

  return (
    <form onSubmit={handleSubmit}>
      <div className="singel__input-field mb-15">
        <label className="input__field-text">
          {t('form.profile.firstNameLabel')}
        </label>
        <input
          name="first_name"
          type="text"
          placeholder={t('form.profile.firstNamePlaceholder')}
          value={values.first_name}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.first_name && <ErrorMsg errors={errors.first_name} />}
      </div>
      <div className="singel__input-field mb-15">
        <label className="input__field-text">
          {t('form.profile.lastNameLabel')}
        </label>
        <input
          name="last_name"
          type="text"
          placeholder={t('form.profile.lastNamePlaceholder')}
          value={values.last_name}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.last_name && <ErrorMsg errors={errors.last_name} />}
      </div>
      <div className="singel__input-field mb-15 ">
        <label className="input__field-text">
          {t('form.profile.emailLabel')}
        </label>
        <input
          name="email"
          type="email"
          disabled
          placeholder={t('form.profile.emailPlaceholder')}
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.email && <ErrorMsg errors={errors.email} />}
      </div>

      <div className="card__header-top mt-60 mb-20">
        <div className="card__title-inner">
          <h4 className="event__information-title">
            {t('form.profile.deliverySectionTitle')}
          </h4>
        </div>
      </div>

      <div className="singel__input-field mb-15">
        <label className="input__field-text">
          {t('form.profile.deliveryNamesLabel')}
        </label>
        <input
          name="delivery_names"
          type="text"
          placeholder={t('form.profile.deliveryNamesPlaceholder')}
          value={values.delivery_names}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.delivery_names && <ErrorMsg errors={errors.delivery_names} />}
      </div>

      <div className="singel__input-field mb-15">
        <label className="input__field-text">
          {t('form.profile.deliveryPhoneLabel')}
        </label>
        <input
          name="delivery_phone"
          type="text"
          placeholder={t('form.profile.deliveryPhonePlaceholder')}
          value={values.delivery_phone}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.delivery_phone && <ErrorMsg errors={errors.delivery_phone} />}
      </div>

      <div className="singel__input-field mb-15">
        <label className="input__field-text">
          {t('form.profile.deliveryAddressLabel')}
        </label>
        <input
          name="delivery_address"
          type="text"
          placeholder={t('form.profile.deliveryAddressPlaceholder')}
          value={values.delivery_address}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.delivery_address && (
          <ErrorMsg errors={errors.delivery_address} />
        )}
      </div>

      <div className="input__btn-wrapper">
        <button
          type="submit"
          disabled={isBtnDisable}
          className={
            isBtnDisable
              ? 'disableBtnStyle w-100 mb-20'
              : 'input__btn w-100 mb-20'
          }
        >
          {t('common.save')}
        </button>
      </div>
    </form>
  )
}
